import React from 'react';
import { useTheme } from '../context/ThemeContext.jsx';
import VideoBackground from '../components/common/VideoBackground.jsx';
import Footer from '../components/common/Footer.jsx';

const HomePage = () => {
  const { colors, spacing, fonts, borderRadius, shadows } = useTheme();

  const pageStyles = { position: 'relative', minHeight: '100vh' };

  const logoStyles = {
    width: '220px',
    height: '220px',
    objectFit: 'contain',
    marginBottom: spacing.scale.xl,
  };

  const mainTitleStyles = {
    fontSize: '4rem',
    fontWeight: fonts.weights.light,
    margin: 0,
    marginBottom: spacing.scale.lg,
    color: '#ffffff',
    textAlign: 'center',
    letterSpacing: '2px',
    textShadow: `2px 2px 4px ${colors.shadow}`,
    fontFamily: fonts.families.secondary,
  };

  const dividerStyles = {
    width: '200px',
    height: '2px',
    background: '#ffffff',
    margin: `${spacing.scale.lg} auto`,
    opacity: 0.8,
  };

  const taglineStyles = {
    fontSize: '1.5rem',
    fontWeight: fonts.weights.light,
    margin: 0,
    color: '#ffffff',
    textAlign: 'center',
    letterSpacing: '1px',
    textShadow: `1px 1px 2px ${colors.shadow}`,
    fontFamily: fonts.families.primary,
  };

  return (
    <div style={pageStyles}>
      <VideoBackground
        src="/assets/VictoriaLondeBackground.mp4"
        fallbackImage="/assets/hero-fallback.jpg"
        overlay={true}
      >
        <img
          src="/assets/logo.png"
          alt="Victoria Londe"
          style={logoStyles}
        />
        <h1 style={mainTitleStyles}>Victoria Londe</h1>
        <div style={dividerStyles} role="presentation" aria-hidden="true" />
        <h2 style={taglineStyles}>Software | Stories | Stuff</h2>
      </VideoBackground>
      <Footer />
    </div>
  );
};

export default HomePage;
